<template>
  <div class="development">
    <div class="container">
      <h2 class="white">{{hadingtext}}</h2>
      <div class="row">
        <div v-for="(element, index) in elements" class="col-l-6 col-m-6 col-s-12">
          <div class="box">
            <div class="title">{{element.title}}</div>
            <div class="text" v-html="element.text"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: ['blockdata'],
    name: 'block-development',
    data() {
      return {
        hadingtext: this.blockdata.heading_text,
        elements: this.blockdata.elements,
        delay: 100
      }
    }
  }
</script>


// WEBPACK FOOTER //
// BlockDevelopment.vue?63f15b52